import { type RefObject, useEffect, useRef } from 'react';

import { useIsInView } from 'utils/hooks';

export const AutoFocus: React.FunctionComponent<{
  elementToFocus: RefObject<{ focus: () => void }>;
}> = ({ children, elementToFocus }) => {
  const ref = useRef(null);
  const isInView = useIsInView(ref);

  useEffect(() => {
    if (isInView) {
      elementToFocus.current?.focus();
    }
  }, [isInView]);

  return <span ref={ref}>{children}</span>;
};
